module.exports = __webpack_public_path__ + "img/fastcharger-request-private.fd308b8e.png";